<template>
  <div >
    <div class="col-sm-12">
      <el-table class="table table-striped table-no-bordered table-hover"
                ref="historyTable"
                :data="items ? items : history"
                v-loading="paging"
                element-loading-spinner="qc-spinner"
                style="width: 100%"
                :row-class-name="rowClass"
                :cell-class-name="cellClass"
                highlight-current-row
                @current-change="selectVerification"
                tooltip-effect="light">
        <el-table-column :min-width="125" label="Date">
          <template slot-scope="props">
            <span>{{formatDate(props.row.recorded)}}</span>
          </template>
        </el-table-column>
        <el-table-column :min-width="180" :show-overflow-tooltip="true" label="Name">
          <template slot-scope="props">
            <span>{{props.row.fields.firstname}} {{props.row.fields.surname}}</span>
          </template>
        </el-table-column>
        <el-table-column :min-width="220" :show-overflow-tooltip="true" label="Institute / Organisation">
          <template slot-scope="props">
            <div v-if="$service.isEmp(props.row.instituteId)">
              <span>{{props.row.fields.employerName ? props.row.fields.employerName : props.row.instituteName}}</span>
            </div>
            <div v-else>
              <div v-if="props.row.instituteNames && props.row.instituteNames.length > 0">
                <div v-for="name in props.row.instituteNames">{{name}}</div>
              </div>
              <div v-else>{{props.row.instituteName}}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column :min-width="120" :show-overflow-tooltip="true" label="Requested By">
          <template slot-scope="props">
            <span>{{props.row.company ? props.row.company : props.row.institute}}</span>
          </template>
        </el-table-column>
        <el-table-column
          :min-width="150"
          :show-overflow-tooltip="true" 
          fixed="right"
          align="center"
          label="Pricing">
          <template slot-scope="props">
            
            <span>{{formatMoney(props.row.total)}}</span>
          </template>
        </el-table-column>
        <slot name="actions" />
      </el-table>
    </div>
    <div v-if="showPagination" class="col-sm-6 pagination-info">
      <p class="category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
    </div>
    <div v-if="showPagination" class="col-sm-6">
      <p-pagination class="pull-right"
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total="pagination.total">
      </p-pagination>
    </div>
  </div>
</template>
<script>

  import PPagination from 'src/components/Pagination.vue'

  import moment from 'moment'
  import accounting from 'accounting'
  import _ from 'lodash'
  
  accounting.settings.currency.symbol = "£";

  export default {
    name: "referral-history-table",
    components: {
      PPagination
    },
    props: {
      items: {type: Array, default: null},
      query: {type: String, default: ""},
      requestedBy: {type: String, default: null},
      //results: {type: Array, default: () => {return []}},
      //types: {type: Array, default: () => {return []}},
      dateRange: {type: Array, default: () => {return []}},
      size: {type: Number, default: 20},
      showPagination: {type: Boolean, default: true}
    },
    data () {
      return {
        result: null,
        highlight: null,
        history: null,
        paging: false,
        total: 0,
        pagination: {
          perPage: 20,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        internalResults: []
      }
    },
    mounted () {
      if(this.$route.query.highlight) {
        this.highlight = this.$route.query.highlight.split(",")
      }
      if(!this.items) {
        this.getHistory()
      }
    },
    activated () {
      if(this.$route.query.highlight) {
        this.highlight = this.$route.query.highlight.split(",")
      }
      if(!this.items) {
        this.getHistory()
      }
    },
    watch: {
      query: _.debounce(function  (value) {
        this.pagination.currentPage = 1
        this.getHistory()
      }, 500),
      requestedBy(value) {
        this.pagination.currentPage = 1
        this.getHistory()
      },
      // results (value) {
      //   this.pagination.currentPage = 1
      //   this.getHistory()
      // },
      // types (value) {
      //   this.pagination.currentPage = 1
      //   this.getHistory()
      // },
      dateRange (value) {
        this.pagination.currentPage = 1
        this.getHistory()
      },
      paginationCurrentPage (value) {
        this.getHistory()
      },
      paginationPerPag (value) {
        this.getHistory()
      }
    },
    computed: {
      paginationCurrentPage () {
        return this.pagination.currentPage
      },
      paginationPerPag () {
        return this.pagination.perPage
      },
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      }
    },
    methods: {
      formatMoney(value) {
        if(!value || value == 0) {
          return '-'
        }
        return accounting.formatMoney(value)
      },
      rowClass(row) {
        // if(this.highlight && this.highlight.includes("" + row.row.id)) {
        //   return 'danger-row'
        // }
        // switch(row.row.result) {
        //   case 'REJECTED':
        //   case 'NOT_FOUND':
        //     return 'warning-row'
        //   default:
            return ''
        // }
      },
      cellClass(row) {
        // if(row.column.label === 'Status') {
        //   switch(row.row.result) {
        //     case 'REJECTED':
        //     case 'NOT_FOUND':
        //       return 'warning-cell'
        //     default:
              return ''
        //   }
        // }
      },
      formatDate (timestamp) {
        var m = moment(timestamp)
        return m.format('DD MMM YYYY')
      },
      getHistory: _.debounce(function () {
        this.paging = true
        this.history = []
        let historyRequest = {
          page: this.pagination.currentPage - 1,
          size: this.size,
          query: this.query,
          organisation: this.requestedBy,
          // results: this.results,
          // types: this.types,
          fromDate: this.dateRange[0],
          toDate: this.dateRange[1],
        }
        this.$api.getReferralHistory(historyRequest)
          .then(response => {
            this.history = response.data.content
            this.pagination.total = response.data.totalSize
            this.total = response.data.totalSize
            this.paging = false
          })
          .catch(error => {
            this.paging = false
          })
      }, 500),
      selectVerification (row, oldRow) {
        if(row) {
          this.$router.push('/verification/history/' + row.id)
        }
      }
    }
  }
</script>
<style>

</style>
